const recsElement = document.querySelector("#genderrecommendations");
document.addEventListener("scroll", checkIfRecsInView);

function removeScrollListener() {
  document.removeEventListener("scroll", checkIfRecsInView);
}

function checkIfRecsInView() {
  var bottom = recsElement.getBoundingClientRect().y - 800;

  if (bottom < window.innerHeight) {
    loadRecs();
    removeScrollListener();
  }
}

function loadRecs() {
  let recentProducts = JSON.parse(localStorage.getItem("recently_viewed")) || {};
  let lastViewDays = (Date.now() - recentProducts["timestamp"]) / 1000 / 60 / 60 / 24;

  if (lastViewDays < 90) {
    fetch(window.Shopify.routes.root + "recommendations/products?section_id=personal-recommendations&product_id=" + recentProducts.products[0] + "&limit=12&intent=related")
      .then((response) => response.text())
      .then((text) => {
        document.getElementById("genderrecommendations").innerHTML = text;
        createCarousel("#recommendedProductsListM");
        createCarousel("#recommendedProductsListW");
        iWish.init();
        showGender();
        setTimeout(() => {
          document.querySelector(".gr-loader").style.display = "none";
          document.querySelectorAll(".home-productlist").forEach((carousel) => (carousel.style.opacity = "1"));
        }, "300");
      })
      .catch((e) => {
        console.error(e);
      });
  } else {
    recentProducts ? localStorage.removeItem("recently_viewed") : "";
    showGender();
    setTimeout(() => {
      document.querySelector(".gr-loader").style.display = "none";
      document.querySelectorAll(".home-productlist").forEach((carousel) => (carousel.style.opacity = "1"));
    }, "300");
  }
}

function showGender() {
  let hideGender = localStorage.getItem("gender_used");
  if (hideGender != "womens") {
    $(".mensonly").css("display", "block").flickity("resize");
    $(".womensonly").css("display", "none");
  } else {
    $(".womensonly").css("display", "block").flickity("resize");
    $(".mensonly").css("display", "none");
  }
}

let test = ""
function createCarousel(location) {
  var $reccarousel = $(location);
  let itemCount = document.querySelector(location).querySelectorAll('.rec--item').length;

  if (itemCount < 4) {
  $reccarousel.flickity({
    cellAlign: "center",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    lazyLoad: 2,
    imagesLoaded: true,
  });
} else {
  $reccarousel.flickity({
    cellAlign: "center",
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: false,
    lazyLoad: 2,
    imagesLoaded: true,
  });
}
}

document.body.addEventListener(
  "click",
  function (event) {
    const parent = event.target.closest(".rec--item");
    const parentSection = event.target.closest(".personal-recs");
    if (parent && parentSection) {
      gtag("event", "recommendation_clicked"), { send_to: "G-5VYXHDTFF7" };
    }

  },
  true
);
